///////////////////////////////////////////
// Custom Page Scroll Detection for TCOE //
///////////////////////////////////////////

(function ($) {
	var $body = $("body"),
		$banner = $(".top-banner"),
		bannerHeight = $banner.outerHeight();

	buildPageEnvironment();

	function buildPageEnvironment() {
		// Create an internal variable scope for each scrolling environment.
		var scroller = window, // container.get(0),
			scheduledAnimationFrame = false,
			lastScrollTop = 0,
			maxScrollTop = document.body.scrollHeight; // document.body.clientHeight;

		// Efficient debouncing using requestAnimationFrame() to manage events on scroll
		// Modified specifically to target .beer-scroll elements
		// @link https://developers.google.com/web/fundamentals/performance/rendering/debounce-your-input-handlers
		function onScroll() {
			// Store the scroll value for later. This currently is not needed.
			lastScrollTop = window.scrollY;

			// Prevent multiple rAF callbacks.
			if (scheduledAnimationFrame) return;

			scheduledAnimationFrame = true;
			requestAnimationFrame(updateHeader);
		}

		// Debounce the window resize call to boost performance on viewport changes
		function debounceWindowResize() {
			debounce(onWindowResize, 250);
		}

		// Update the maximum scrolling capacity on resize, in the event of a style or dimension change.
		function onWindowResize() {
			maxScrollTop = document.body.scrollHeight; // scroller.scrollHeight - scroller.clientHeight;
			bannerHeight = $banner.outerHeight();

			// Prevent multiple rAF callbacks.
			if (scheduledAnimationFrame) return;

			scheduledAnimationFrame = true;
			// Fire the toggle detection function to show/hide the nav elements on resize, as eventually all sections will be hiding content by phone size
			requestAnimationFrame(updateHeader);
		}

		function updateHeader() {
			// maxScrollTop = document.body.scrollHeight; // scroller.scrollHeight - scroller.clientHeight;

			if (lastScrollTop >= bannerHeight) {
				$body.addClass("hide-logo");
			} else {
				$body.removeClass("hide-logo");
			}

			scheduledAnimationFrame = false;
		}

		scroller.addEventListener("scroll", onScroll);
		window.addEventListener("resize", debounceWindowResize);

		updateHeader();
	}

	// DeBounce Function
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
				args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}
})(jQuery);
